import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background-50 px-4 text-center">
      <h1 className="text-6xl font-bold text-foreground-300 mb-4 font-heading">404</h1>
      <h2 className="text-2xl font-bold text-foreground-900 mb-2 font-heading">{t("notfound.title")}</h2>
      <p className="text-base text-foreground-600 mb-8 font-body">{t("notfound.desc")}</p>
      <button
        type="button"
        onClick={() => navigate("/")}
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer font-body"
      >
        <i className="ri-arrow-left-line" />
        {t("notfound.back")}
      </button>
    </div>
  );
}